package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Keychain_item(
  public val id: String,
  public val keychain_id: String,
  public val payload: String,
  public val order_index: Long,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
